// removed by extract-text-webpack-plugin
module.exports = {"labelTypography":"_2bpHv","smallLinkTypography":"DUJY-","titleTypography":"_1_0A2","cardTitleTypography":"_1fnbu","featurename":"u5-iB","truncate":"_3MoYY","base":"_3wxtk","statusWarnings":"_1Bt5n","statusSuccess":"_2HvIm","statusError":"_38PxE","noRecord":"_1U4Rt","buttonContainer":"_25MxX","icon":"_2U-v-","crossIcon":"_3n0hw","buttonGreenBorder":"_2UJIR","buttonGrayBorder":"-iAV7"};


//////////////////
// WEBPACK FOOTER
// ./src/views/FeatureToggle/components/FeatureToggleList.scss
// module id = 2693
// module chunks = 0